// Função para buscar todos os planos
export const fetchPlans = async () => {
  try {
    const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/rest/v1/plans?select=*&order=display_order.asc`, {
      headers: {
        'apikey': import.meta.env.VITE_SUPABASE_ANON_KEY,
        'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Erro ao buscar planos');
    }

    const data = await response.json();
    return data || [];
  } catch (err) {
    console.error('Erro ao buscar planos:', err);
    throw err;
  }
};

// Função para criar um novo plano
export const createPlan = async (planData: any) => {
  try {
    const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/rest/v1/plans`, {
      method: 'POST',
      headers: {
        'apikey': import.meta.env.VITE_SUPABASE_ANON_KEY,
        'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
        'Content-Type': 'application/json',
        'Prefer': 'return=representation',
      },
      body: JSON.stringify(planData),
    });

    if (!response.ok) {
      throw new Error('Erro ao criar plano');
    }

    const data = await response.json();
    return data[0]; // Retorna o primeiro item do array
  } catch (err) {
    console.error('Erro ao criar plano:', err);
    throw err;
  }
};

// Função para atualizar um plano
export const updatePlan = async (id: string, planData: any) => {
  try {
    const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/rest/v1/plans?id=eq.${id}`, {
      method: 'PATCH',
      headers: {
        'apikey': import.meta.env.VITE_SUPABASE_ANON_KEY,
        'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
        'Content-Type': 'application/json',
        'Prefer': 'return=representation',
      },
      body: JSON.stringify(planData),
    });

    if (!response.ok) {
      throw new Error('Erro ao atualizar plano');
    }

    const data = await response.json();
    return data[0]; // Retorna o primeiro item do array
  } catch (err) {
    console.error('Erro ao atualizar plano:', err);
    throw err;
  }
};

// Função para excluir um plano
export const deletePlan = async (id: string) => {
  try {
    const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/rest/v1/plans?id=eq.${id}`, {
      method: 'DELETE',
      headers: {
        'apikey': import.meta.env.VITE_SUPABASE_ANON_KEY,
        'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Erro ao excluir plano');
    }

    return true;
  } catch (err) {
    console.error('Erro ao excluir plano:', err);
    throw err;
  }
}; 